import React from "react";

const Bubble = ({color}) => {


    return (
        <span style={{
            height: 16,
            width: 16,
        }}>
            <svg width={16} height={16}>
                <circle cx={8} cy={8} r={7} fill={color} width={1} stroke={'#2c2c2c'}/>
            </svg>
        </span>
    )


}

export default Bubble
